import {
  ConnectDevicesIcon,
  ContrastIcon,
  ScanIcon,
  SpeedTestIcon,
  TemperatureIcon,
} from "@ubnt/icons";
import { IHeroSection } from "pages/LayoutComponents/Hero/Hero.types";
import React from "react";
import { ICondensedFeatureItem } from "pages/LayoutComponents/CondensedFeatureGrid/CondensedFeatureGrid.types";

import heroJpg from "./assets/videos/hero.jpg";
import heroMp4 from "./assets/videos/hero.mp4";
import flagship1Mp4 from "./assets/feature-tiles/flagship-1.mp4";
import flagship1Jpg from "./assets/feature-tiles/flagship-1.jpg";
import flagship2Mp4 from "./assets/feature-tiles/flagship-2.mp4";
import flagship2Jpg from "./assets/feature-tiles/flagship-2.jpg";
import flagship3Mp4 from "./assets/feature-tiles/flagship-3.mp4";
import flagship3Jpg from "./assets/feature-tiles/flagship-3.jpg";
import flagship4Mp4 from "./assets/feature-tiles/flagship-4.mp4";
import flagship4Jpg from "./assets/feature-tiles/flagship-4.jpg";

export const HERO_SECTIONS = [
  {
    id: 0,
    icon: <ConnectDevicesIcon size="original" color="#fff" />,
    label: "The WiFi Industry Standard",
    poster: heroJpg,
    src: heroMp4,
    playbackTimeInSeconds: 15,
  },
] satisfies IHeroSection[];

export const FEATURE_COMPLETE_TILES = [
  {
    id: "spectral-scanning",
    assets: {
      src: flagship1Mp4,
      poster: flagship1Jpg,
      icon: <ScanIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.flagship.featureTiles.spectralScanning.title",
    description: "wifi.flagship.featureTiles.spectralScanning.description",
    isSelectedModelsOnly: true,
  },
  {
    id: "color-options",
    assets: {
      src: flagship2Mp4,
      poster: flagship2Jpg,
      icon: <ContrastIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.flagship.featureTiles.colors.title",
    description: "wifi.flagship.featureTiles.colors.description",
  },
  {
    id: "optimized",
    assets: {
      src: flagship3Mp4,
      poster: flagship3Jpg,
      icon: <TemperatureIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.flagship.featureTiles.optimized.title",
    description: "wifi.flagship.featureTiles.optimized.description",
    isSelectedModelsOnly: true,
  },
  {
    id: "compact-10gbe",
    assets: {
      src: flagship4Mp4,
      poster: flagship4Jpg,
      icon: <SpeedTestIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.flagship.featureTiles.compact10gbe.title",
    description: "wifi.flagship.featureTiles.compact10gbe.description",
    isSelectedModelsOnly: true,
  },
] satisfies Array<ICondensedFeatureItem>;
